import { Input, OnInit, Component } from '@angular/core';

import { GridsterConfig, GridsterItem, GridType, CompactType, DisplayGrid } from './../../gridster/public-api';
import { RaDashboardService } from './../ra.dashboard.service';

@Component({
  selector: 'ra-dashboard',
  templateUrl: './ra.dashboard.control.html',
  styleUrls: ['./ra.dashboard.control.css'],
  // providers: [SafeHtmlPipe],
  // encapsulation: ViewEncapsulation.None
})
export class RADashboardControl implements OnInit {

  constructor(private dashboardService: RaDashboardService) {

  }
  @Input() dashboardId: number
  @Input() width: string
  @Input() height: string
  @Input() globalFilter: any


  widgetList = Array<GridsterItem>();
  options: GridsterConfig;

  ngOnInit(): void {
    /// default gridster configuration
    this.options = {
      gridType: GridType.ScrollVertical,
      compactType: CompactType.None,
      margin: 0,
      outerMargin: true,
      outerMarginTop: null,
      outerMarginRight: null,
      outerMarginBottom: null,
      outerMarginLeft: null,
      useTransformPositioning: true,
      mobileBreakpoint: 640,
      minCols: 100,
      maxCols: 100,
      minRows: 100,
      maxRows: 2000,
      maxItemCols: 150,
      minItemCols: 1,
      maxItemRows: 150,
      minItemRows: 1,
      maxItemArea: 2500,
      minItemArea: 1,
      defaultItemCols: 5,
      defaultItemRows: 5,
      fixedColWidth: 5,
      fixedRowHeight: 5,
      keepFixedHeightInMobile: false,
      keepFixedWidthInMobile: false,
      scrollSensitivity: 10,
      scrollSpeed: 20,
      enableEmptyCellClick: false,
      enableEmptyCellContextMenu: false,
      enableEmptyCellDrop: false,
      enableEmptyCellDrag: false,
      emptyCellDragMaxCols: 50,
      emptyCellDragMaxRows: 50,
      ignoreMarginInRow: true,
      draggable: {
        enabled: true,
        // dragHandleClass: 'header',
        // ignoreContent: true

      },
      resizable: {
        enabled: true,
      },
      swap: true,
      pushItems: false,
      disablePushOnDrag: true,
      disablePushOnResize: false,
      pushDirections: { north: true, east: true, south: true, west: true },
      pushResizeItems: true,
      displayGrid: DisplayGrid.OnDragAndResize,
      disableWindowResize: false,
      disableWarnings: false,
      scrollToNewItems: true,
      autoResizeonDrag: false,
      // itemResizeCallback: (item) => this.itemResize(item),
      //itemChangeCallback: (item) => this.itemCallBack(item),
      //itemInitCallback: (item) => this.itemInitCallback(item)
    }
    this.loadWidgets();
  }

  loadWidgets() {    
    var widgets = this.dashboardService.getWidgetsbyDashboardID(this.dashboardId);
    widgets.forEach(element => {
      var widget=this.dashboardService.getWidgetInformation(element.id);
      this.widgetList.push({ x: 0, y: 0, cols: 30, rows: 20, widgetInfo:widget });
    });
  }
}